export default __webpack_public_path__ + "static/088-9071bfd6c176d279f656c783c1001902.jpg";